export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";